import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex } from '../grid';
import { Icon } from '../icons';
import { Subheading } from '../typography';

const CartHeader = ({ onCloseCartClick }) => (
  <Wrapper flexDirection="column" alignItems="center" p={1}>
    <Flex mb="0.5rem" justifyContent="center" width="100%" alignItems="center">
      <Flex flex={1} />
      <Subheading>Your order</Subheading>
      <Flex flex={1} justifyContent="flex-end">
        <button type="button" onClick={onCloseCartClick} aria-label="close">
          <Icon name="cross" width="24px" height="24px" fill="greyPrimary" />
        </button>
      </Flex>
    </Flex>
  </Wrapper>
);

const Wrapper = styled(Flex)`
  border-bottom: 4px solid ${({ theme }) => theme.colors.background};
`;

CartHeader.propTypes = {
  onCloseCartClick: PropTypes.func.isRequired,
};

export { CartHeader };
